module.exports = __webpack_public_path__ + "static/media/internal_error.bcbbdb46.png";